<template>
  <keep-alive v-if="!!parameterComponent">
    <component :is="parameterComponent" />
  </keep-alive>
  <div v-else>asthma parameter not found</div>
</template>

<script>
import { PropsDefinition, Computed } from '@/_typedefs'
import { Component } from 'vue'
import HypothesisParameterVue from './Hypothesis/HypothesisParameter.vue'

/**
 * @typedef {Object} AsthmaParameterNodeProps
 * @property {string} kind
 */

export default {
  name: 'AsthmaParameterNode',
  /** @type {PropsDefinition<AsthmaParameterNodeProps>} */
  props: {
    kind: {
      type: String,
      required: true,
    },
  },
  computed: {
    /** @type {Computed<Component?>} */
    parameterComponent() {
      const parameterMap = {
        'asthma:hypothesis': HypothesisParameterVue,
      }

      return parameterMap[this.kind] ?? null
    },
  },
}
</script>

<style></style>
